export const PageActivityEvents = {
  VIEW: 'pageActivity_view',
  CONTENT_OPENED: 'pageActivity_contentOpened',
} as const;

export const PageActivityFeatures = {
  CUSTOM_LANDING: 'customLanding',
} as const;

export const PageActivityActions = {
  VIEW: 'view',
  CONTENT_OPENED: 'contentOpened',
} as const;

export const PageActivityLevels = {
  LANDING: 'landing',
  SECTION: 'section',
  FOLDER: 'folder',
} as const;

export type PageActivityFeature =
  (typeof PageActivityFeatures)[keyof typeof PageActivityFeatures];
export type PageActivityAction =
  (typeof PageActivityActions)[keyof typeof PageActivityActions];
export type PageActivityLevel =
  (typeof PageActivityLevels)[keyof typeof PageActivityLevels];
